// extracted by mini-css-extract-plugin
var _1 = "ZpTZ0jAUU4RRBBbGVK0R";
var _2 = "nQrULF0zaRHl_OH1_R4o";
export { _1 as "list", _2 as "title" }
